export default {
  meta: {
    title: '实验工作台',
  },
};
